import {Injectable} from '@angular/core';

/**
 * Translations for reminder statuses.
 */
@Injectable()
export class ReminderStatusTranslationsService {
  public i18nOpenStatus: any = $localize`:@@general.status.open:Open`;
  public i18nResolvedStatus: any = $localize`:@@general.status.resolved:Resolved`;
  public i18nOverdueStatus: any = $localize`:@@general.status.overdue:Overdue`;
  public i18nComment: any = $localize`:@@general.formLabel.comment:Comment`;
  public i18nDeadline: any = $localize`:@@general.formLabel.deadline:Deadline`;
  public i18nErrorFileSizeTooLarge: any = $localize`:@@alertService.error.fileSizeExceeds5MB:File size exceeds 5 MB`;
  public i18nErrorCannotUploadAttachment: any = $localize`:@@alertService.error.cannotUploadAttachment:Error occurred. Could not upload attachment.`;
  public i18nErrorCannotDownloadAttachment: any = $localize`:@@alertService.error.cannotDownloadAttachment:Error occurred. Could not download attachment.`;
  public i18nSuccessReminderCreate: any = $localize`:@@alertService.success.reminderCreate:Reminder was created successfully!`;
  public i18nSuccessReminderUpdate: any = $localize`:@@alertService.success.reminderUpdate:Reminder was updated successfully!`;
  public i18nErrorReminderCreate: any = $localize`:@@alertService.error.reminderCreate:Reminder could not be created!`;
  public i18nErrorReminderUpdate: any = $localize`:@@alertService.error.reminderUpdate:Reminder could not be updated!`;
  constructor() { }
}
